import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=342536c8&scoped=true&"
import script from "./DocList.vue?vue&type=script&lang=js&"
export * from "./DocList.vue?vue&type=script&lang=js&"
import style0 from "./DocList.vue?vue&type=style&index=0&id=342536c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342536c8",
  null
  
)

export default component.exports